import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { PermissionLevels } from 'utils/permission'
import {
  ButtonGroup
} from 'react-bootstrap'
import CardPicker from 'routes/Board/CardPicker'
import Button from 'components/Button'

export class AddSubCard extends React.Component {
  static propTypes = {
    statusId: PropTypes.number.isRequired,
    cardId: PropTypes.number.isRequired,
    close: PropTypes.func.isRequired,

    boardId: PropTypes.number.isRequired,
    childIds: PropTypes.array.isRequired,

    requestChangeCardParent: PropTypes.func.isRequired,
    requestAddNewChildCard: PropTypes.func.isRequired
  }

  state = {
    statusId: this.props.statusId,
    cardId: null,
    cardName: null,
    template: null,
  }

  cardFilter = ({ id }) => (id !== this.props.cardId && !this.props.childIds.includes(id))

  handleStatusChange = (statusId) => {
    this.setState({
      statusId
    })
  }

  handleCardChange = (cardId, cardName) => {
    this.setState({
      cardId,
      cardName
    })
  }

  handleTemplateChange = (template) => {
    this.setState({
      template,
    })
  }

  handleAddClick = () => {
    const {
      cardId: parentId,
      close,

      requestChangeCardParent,
      requestAddNewChildCard
    } = this.props
    const {
      cardId,
      statusId,
      cardName,
      template,
    } = this.state

    if (cardId) {
      requestChangeCardParent({
        cardId,
        parentId
      })
    } else {
      requestAddNewChildCard({
        statusId,
        name: cardName,
        parentId,
        template: template !== 'empty' ? { type: 'card', id: +template } : 'empty',
      })
    }

    close()
  }

  render () {
    const {
      boardId,
      statusId
    } = this.props
    const {
      statusId: selectedStatusId,
      cardId,
      cardName,
    } = this.state

    return (
      <React.Fragment>
        <CardPicker
          currentBoardId={boardId}
          currentStatusId={statusId}
          requiredPermissionLevel={PermissionLevels.MEMBER}
          isTemplate={false}
          cardFilter={this.cardFilter}
          onStatusChange={this.handleStatusChange}
          onCardChange={this.handleCardChange}
          onTemplateChange={this.handleTemplateChange}
        />
        <ButtonGroup>
          <Button
            bsStyle='primary'
            disabled={!selectedStatusId || (!cardId && !cardName)}
            onClick={this.handleAddClick}
          >
            <FormattedMessage id='ADD' />
          </Button>
        </ButtonGroup>
      </React.Fragment>
    )
  }
}

export default AddSubCard
